import React from "react";
// javascript library that creates a parrallax effect
import Rellax from "rellax";
// reactstrap components
import { Container, 
    Row, 
    Col,
    Card,
    CardBody
} from "reactstrap";
// core components

// sections for this page
// import Politica from "./Procesos/Procesos.js";
import PresentationHeader from "components/Headers/PresentationHeader2.js";

function Procesos() {

  // const [tooltipOpen, setTooltipOpen] = useState(false);
  // const toggle = () => setTooltipOpen(!tooltipOpen);
  
  React.useEffect(() => {
    document.body.classList.add("presentation-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    // initialise Rellax for this page
    if (window.innerWidth >= 991) {
      setTimeout(function () {
        new Rellax(".rellax", {
          center: true,
        });
      }, 5000);
      new Rellax(".rellax-header");
      new Rellax(".rellax-text");
    }

    // we need to add a script for the github buttons
    let script = document.createElement("script");
    script.src = "https://buttons.github.io/buttons.js";
    script.id = "github-buttons-script-id";
    document.body.appendChild(script);

    return function cleanup() {
      document.body.classList.remove("tramites-page");
      document.body.classList.remove("sidebar-collapse");

      // we need to remove the script when we change the page
      script.parentNode.removeChild(script);
    };
  });
  return (
    <>
      <div className="wrapper">
        <PresentationHeader titulo="Procesos y procedimientos"/>
        <div id= "servicio" style={{backgroundColor: "#f9f9f9"}}>
          <Container className="fluid">
            <Row>
              <Col md="12">
                <Card style={{marginTop:"2%"}}>
                  <CardBody>
                    <Row className="justify-content-center">
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/3.3 MAPA DE PROCESOS.pdf")} style={{textDecoration: "none !important"}} target="_black">
                            <img
                              alt="Imagen con referencia Mapa Procesos"
                              width="80px"
                              src={require("assets/img/Notaria/PDF.png")}
                            ></img>
                            <h6>MAPA DE PROCESOS</h6>
                          </a>
                        </center>
                      </Col>
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/INSTRUCTIVO MATRIMONIO.pdf")} style={{textDecoration: "none !important"}} target="_black">
                            <img
                              alt="Imagen con referencia Instructivo Matrimonios"
                              width="80px"
                              src={require("assets/img/Notaria/PDF.png")}
                            ></img>
                            <h6>INSTRUCTIVO MATRIMONIO</h6>
                          </a>
                        </center>
                      </Col>
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/PROCEDIMIENTO  DE LA  ESCRITURA.pdf")} style={{textDecoration: "none !important"}} target="_black">
                            <img
                              alt="Imagen con referencia Escritura"
                              width="80px"
                              src={require("assets/img/Notaria/PDF.png")}
                            ></img>
                            <h6>PROCEDIMIENTO  DE LA  ESCRITURA</h6>
                          </a>
                        </center>
                      </Col>
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/PROCEDIMIENTO DECLARACION EXTRAPROCESO VERSION 2.pdf")} style={{textDecoration: "none !important"}} target="_black">
                            <img
                              alt="Imagen con referencia Declaracion Procedimiento"
                              width="80px"
                              src={require("assets/img/Notaria/PDF.png")}
                            ></img>
                            <h6>PROCEDIMIENTO DECLARACION EXTRAPROCESO VERSION 2</h6>
                          </a>
                        </center>
                      </Col>
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/PROCEDIMIENTO REGISTRO CIVIL.pdf")} style={{textDecoration: "none !important"}} target="_black">
                            <img
                              alt="Imagen con referencia Registro Civil"
                              width="80px"
                              src={require("assets/img/Notaria/PDF.png")}
                            ></img>
                            <h6>PROCEDIMIENTO REGISTRO CIVIL</h6>
                          </a>
                        </center>
                      </Col>
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/SOPORTE PARA RECONOCIMIENTO DE HIJO.pdf")} style={{textDecoration: "none !important"}} target="_black">
                            <img
                              alt="Imagen con referencia Reconocimiento HIjo"
                              width="80px"
                              src={require("assets/img/Notaria/PDF.png")}
                            ></img>
                            <h6>SOPORTE PARA RECONOCIMIENTO DE HIJO</h6>
                          </a>
                        </center>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Procesos;